<template>
  <div class="mt-3 mb-3 position-relative text-center">
    <!-- <p class="text-sm mb-2 text-secondary text-border d-inline z-index-2 bg-white px-3" >
          {{ textMessage }}
        </p> -->
  </div>
  <!-- <div class="social-networks">
        <div>
            <button class="btn btn-outline-light py-2" type="button" @click="handleSignInGoogle()" >
                <IconVue name="google-logo" />
                <span class="form-check-label ps-2">Google</span>
            </button>
        </div>
        <div>
            <a class="btn btn-outline-light py-2" href="#">
                <IconVue name="facebook-logo" />
                <span class="form-check-label ps-2">Facebook</span>
            </a>
        </div>
    </div> -->
</template>

<script>
import firebaseConfig from "@/config/firebaseConfig.js"
/* import IconVue from "@/components/Icon.vue"; */
import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import axios from 'axios'
firebaseConfig
const provider = new GoogleAuthProvider();
const auth = getAuth();

export default {
  name: "SocialNetwork",
  inject: ["api_provider", "urls_server", "securedWebStorage"],
  components: {
    /* IconVue, */
  },
  props: {
    textMessage: {
      type: String,
      default: ""
    },
  },
  methods: {
    async handleSignInGoogle() {
      try {
        provider.setCustomParameters({
          prompt: 'select_account'
        });
        const result = await signInWithPopup(auth, provider);

        const email = result.user.email;
        const session_token = result._tokenResponse.idToken;

        let postData = {
          email: email,
          session_token: session_token,
        };

        const response = await this.api_provider.postLogin(this.urls_server.login_google, postData);
        if (response.data.success) {
          // Tokens en cookies HttpOnly (BFF opaco); el front solo recibe el perfil.
          const userResponse = response.data.user_response || {};
          this.$store.commit("setSession", {
            id: userResponse.id,
            name: userResponse.name,
            profile: userResponse.profile,
            avatar: userResponse.avatar_url,
            role: (response.data.user || {}).role,
          });
          this.$router.push({ path: "/dashboard" });
        }

      } catch (error) {
        console.log("ERROR handleSignInGoogle", error);
      }
    }
  },
};
</script>

<style scoped>
.social-networks {
  display: flex;
  justify-content: center;
  padding-top: 5px;
  gap: 10px;
}

.social-networks a.btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-networks span.form-check-label {
  color: var(--dark-gray);
  text-transform: none;
  padding-bottom: 2px;
}

.social-networks div {
  width: 100%;
}

.social-networks a:hover {
  text-decoration: none;
}

.btn-outline-light {
  border-radius: 50px;
  border: 1px solid var(--dark-gray);
  width: 100%;
}

.btn-outline-light:hover:not(.active) {
  border: 1px solid var(--dark-gray);
}

.text-border:before {
  right: 0.5em;
  margin-left: -50%;
}

.text-border:after {
  left: 0.5em;
  margin-right: -50%;
}

.text-border:before {
  background: linear-gradient(90deg,
      transparent,
      rgba(117, 117, 117, 0.4),
      rgba(117, 117, 117, 0.4));
}

.text-border:after {
  background: linear-gradient(90deg,
      rgba(117, 117, 117, 0.4),
      rgba(117, 117, 117, 0.4),
      transparent);
}

.text-border:after,
.text-border:before {
  content: "";
  display: inline-block;
  width: 30%;
  height: 1px;
  position: relative;
  vertical-align: middle;
}
</style>
